import React, { useState } from 'react';
import { Layout, Page } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { InvestigationWorkbench } from './pages/InvestigationWorkbench';
import { Outbox } from './pages/Outbox';
import { Ledger } from './pages/Ledger';
import { FrictionQueue } from './pages/FrictionQueue';
import { Checks } from './pages/Checks';
import { CheckDetail } from './pages/CheckDetail';
import { Integrations } from './pages/Integrations';
import { Rules } from './pages/Rules';
const allChecks = [{
  id: 1,
  retailer: 'Dollar General',
  check: '#DG-9982',
  date: 'Feb 18, 2026',
  status: 'not-started',
  deduction: '$48,200',
  approved: 0,
  rejected: 0,
  pending: 5
}, {
  id: 2,
  retailer: 'Dollar General',
  check: '#DG-8821',
  date: 'Feb 18, 2026',
  status: 'in-progress',
  deduction: '$12,500',
  approved: 12,
  rejected: 8,
  pending: 20
}, {
  id: 3,
  retailer: 'Walmart',
  check: '#WM-2219',
  date: 'Feb 17, 2026',
  status: 'in-progress',
  deduction: '$31,800',
  approved: 10,
  rejected: 5,
  pending: 20
}, {
  id: 4,
  retailer: 'Dollar General',
  check: '#DG-1102',
  date: 'Feb 2, 2026',
  status: 'completed',
  deduction: '$8,900',
  approved: 6,
  rejected: 2,
  pending: 0
}, {
  id: 5,
  retailer: 'Dollar General',
  check: '#DG-5591',
  date: 'Jan 16, 2026',
  status: 'completed',
  deduction: '$5,400',
  approved: 1,
  rejected: 0,
  pending: 0
}, {
  id: 6,
  retailer: 'Target',
  check: '#TGT-3321',
  date: 'Jan 10, 2026',
  status: 'completed',
  deduction: '$15,200',
  approved: 32,
  rejected: 0,
  pending: 0
}];
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('dashboard');
  const [selectedCheckId, setSelectedCheckId] = useState<number | null>(null);
  const handleNavigate = (page: Page) => {
    setSelectedCheckId(null);
    setCurrentPage(page);
  };
  const renderPage = () => {
    if (currentPage === 'checks' && selectedCheckId !== null) {
      const check = allChecks.find(c => c.id === selectedCheckId);
      if (check) {
        return <CheckDetail check={check} onBack={() => setSelectedCheckId(null)} onNavigate={handleNavigate} data-id="element-0" />;
      }
    }
    switch (currentPage) {
      case 'dashboard':
        return <Dashboard onNavigate={handleNavigate} data-id="element-1" />;
      case 'checks':
        return <Checks onSelectCheck={id => setSelectedCheckId(id)} data-id="element-2" />;
      case 'workbench':
        return <InvestigationWorkbench data-id="element-3" />;
      case 'outbox':
        return <Outbox data-id="element-4" />;
      case 'ledger':
        return <Ledger data-id="element-5" />;
      case 'friction':
        return <FrictionQueue data-id="element-6" />;
      case 'settings-integrations':
        return <Integrations data-id="element-7" />;
      case 'settings-rules':
        return <Rules data-id="element-8" />;
      default:
        return <Dashboard data-id="element-9" />;
    }
  };
  return <Layout currentPage={currentPage} onNavigate={handleNavigate} data-id="element-10">
      {renderPage()}
    </Layout>;
}